import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'salesIcpConfig'

export type SalesIcpWeights = {
  isClient: number
  hasWonDeal: number
  sectorMatch: number
  openDeals: number
  recentActivity: number
}

export type SalesIcpThresholds = {
  strong: number
  medium: number
}

export type SalesIcpConfig = {
  _id?: string
  _firmId?: string
  weights: SalesIcpWeights
  sectorIds: string[]
  recentActivityDays: number
  minOpenDeals: number
  thresholds: SalesIcpThresholds
  isDefault?: boolean
}

export type SalesIcpConfigPayload = {
  weights: SalesIcpWeights
  sectorIds: string[]
  recentActivityDays: number
  minOpenDeals: number
  thresholds: SalesIcpThresholds
}

const get = (axios: IFactoryFunctionRequest<any, any>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
  })
}

const upsert = (axios: IFactoryFunctionRequest<any, any>) => (data: SalesIcpConfigPayload) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2`,
    data,
  })
}

const recompute = (axios: IFactoryFunctionRequest<any, any>) => (
  data: { companyId?: string, force?: boolean } = {},
) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/recompute`,
    data,
  })
}

export default (axios: AxiosInstance) => ({
  get: get(useAxios(axios)),
  upsert: upsert(useAxios(axios)),
  recompute: recompute(useAxios(axios)),
})
